// @ts-nocheck
import React, { useEffect, useRef, useCallback, useState } from "react";
import * as pc from "playcanvas";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
} from "@playcanvas/react/components";
import { Texture } from "@playcanvas/engine"; // For texture loading

import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import {
  radians,
  getDeviceType,
  checkCameraPermission,
  requestCameraPermission,
  checkGyroscopePermission,
  requestGyroscopePermission,
} from "src/utils/game";

export default function AugmentedRealityViewer() {
  const [cameraPermissionStatus, setCameraPermissionStatus] =
    useState<string>("");
  const [gyroscopePermissionStatus, setGyroscopePermissionStatus] =
    useState<string>("");
  const [isGyroscopeGainted, setIsGyroscopeGainted] = useState<boolean>(false);

  const [isArStarted, setIsArStarted] = useState<boolean>(false);

  const latestDetectedPosition = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestDetectedRotation = useRef<pc.Vec3>(new pc.Quat(0, 0, 0, 0));

  const latestChildPosition = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestChildRotation = useRef<pc.Vec3>(new pc.Quat(0, 0, 0, 0));

  const latestCameraData = useRef(null);

  const cameraScriptRef = useRef();
  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);

  const gsplatRef = useRef();
  const isTrackerFound = useRef<boolean>(false);
  const latestObjectMat4Ref = useRef(new pc.Mat4());

  const arCameraEntityRef = useRef<pc.Entity>(null);
  const arCameraEntityLookingPointRef = useRef<pc.Entity>(null);

  const gsplatEntity = useRef<pc.Entity>(null);
  const gsplatRotateEntity = useRef<pc.Entity>(null);

  const deviceType = getDeviceType();

  useEffect(() => {
    //checkCamera();
    //checkGyroscope();
    grantGyroscopePermission();
  }, []);

  // useEffect(() => {
  //   //alert(cameraPermissionStatus + " " + gyroscopePermissionStatus);
  //   if (cameraPermissionStatus == "granted" && deviceType == "desktop") {
  //     setIsArStarted(true);
  //   } else if (
  //     cameraPermissionStatus == "granted" &&
  //     gyroscopePermissionStatus == "granted"
  //   ) {
  //     setIsArStarted(true);
  //   }
  // }, [deviceType, cameraPermissionStatus, gyroscopePermissionStatus]);
  useEffect(() => {
    if (deviceType == "desktop" || gyroscopePermissionStatus == "granted") {
      setIsArStarted(true);
    }
  }, [deviceType, cameraPermissionStatus, gyroscopePermissionStatus]);

  const checkCamera = async () => {
    const cameraStatus = await checkCameraPermission();
    setCameraPermissionStatus(cameraStatus);
  };

  const grantCameraPermission = async () => {
    const cameraStatus = await requestCameraPermission();
    setCameraPermissionStatus(cameraStatus);
  };

  const checkGyroscope = async () => {
    const gyroscopeStatus = await checkGyroscopePermission();
    setGyroscopePermissionStatus(gyroscopeStatus);
  };

  const grantGyroscopePermission = async () => {
    const gyroscopeStatus = await requestGyroscopePermission();
    setGyroscopePermissionStatus(gyroscopeStatus);
  };

  const MainCamera = () => {
    const app = useApp();

    useEffect(() => {
      cameraScriptRef.current._camera.clearColor = new pc.Color(0, 0, 0, 0);
      app.on("update", onUpdate);
      return () => app.off("update", onUpdate);
    }, []);

    const onUpdate = () => {
      if (latestCameraData.current) {
        cameraScriptRef.current._camera.fov = latestCameraData.current.fov;
      }
    };

    return (
      <Entity>
        <Camera
          nearClip={0.0001}
          farClip={10000}
          position={[0, 0, 0]}
          rotation={[0, 0, 0]}
        />
        <Script ref={cameraScriptRef} script={CameraControls} />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, 0]}></Entity>
      </Entity>
    );
  };

  const ArObject = () => {
    const app = useApp();
    const worldEntity = useRef<pc.Entity>(null);
    const arObjectEntity = useRef<pc.Entity>(null);

    const trackingScale = new pc.Vec3(0.001, 0.001, 0.001);
    const slamScale = new pc.Vec3(0.002, 0.002, 0.002);
    const resetRotation = new pc.Quat(0, 0, 0, 1);

    useEffect(() => {
      app.on("update", onUpdate);
      return () => app.off("update", onUpdate);
    }, []);

    const onUpdate = () => {
      if (
        arObjectEntity.current &&
        latestDetectedPosition.current &&
        latestDetectedRotation.current
      ) {
        const pos = latestDetectedPosition.current;
        const quat = latestDetectedRotation.current;
        const childPos = latestChildPosition.current;
        const childRot = latestChildRotation.current;

        arObjectEntity.current.setPosition(
          new pc.Vec3(childPos.x, childPos.y, childPos.z),
        );
        arObjectEntity.current.setRotation(
          new pc.Quat(childRot.x, childRot.y, childRot.z, childRot.w),
        );

        if (isTrackerFound.current) {
          gsplatEntity.current.setLocalScale(trackingScale);
          gsplatRotateEntity.current.setLocalRotation(resetRotation);
        } else {
          gsplatEntity.current.setLocalScale(slamScale);
        }
      }
    };

    return (
      <Entity ref={arObjectEntity}>
        <Entity position={[0, 0, 0]} rotation={(0, 0, 0)} scale={[1, 1, 1]}>
          <Entity
            ref={gsplatEntity}
            rotation={[90, 0, 0]}
            scale={[0.0005, 0.0005, 0.0005]}
          >
            <Entity ref={gsplatRotateEntity} rotation={[0, 0, 0]}>
              <SogSplat
                url={
                  "https://assets.deepworldmodel.ai/ar/3dgs/xiqu_remove_top.sog"
                }
              />
              {/*<SogSplat url={"model/xiqu_remove_top.sog"} />*/}
            </Entity>
          </Entity>
          {/*        <Entity rotation={[0,0,0]} scale={[0.1,0.1,0.1]}>
          <Render type="box" />
        </Entity>*/}
        </Entity>
      </Entity>
    );
  };

  const installCameraNearFar = (
    app: pc.Application,
    gsplatEntity: pc.Entity,
  ) => {
    const device = app.graphicsDevice;
    const gsplatMat =
      app.scene.gsplat.material || gsplatEntity.gsplat?.material;
    if (!gsplatMat) return () => {};
    if (!hiddenNearRef.current || !hiddenFarRef.current) {
      return () => {};
    }
    const glsl = `
      uniform vec3 uCutA;       // camera position in WORLD space
      uniform vec3 uCutB;       // robot position in WORLD space
      uniform float uCutRadius; // cylinder radius of the cutaway
      uniform float uCutFeather;// soft edge transition distance

      // Calculate the shortest distance from a point (p) to a line segment (a to b)
      float segDist(vec3 p, vec3 a, vec3 b) {
        vec3 pa = p - a;
        vec3 ba = b - a;
        float h = clamp(dot(pa, ba) / max(dot(ba, ba), 1e-6), 0.0, 1.0);
        return length(pa - ba * h);
      }

      void modifySplatCenter(inout vec3 center) {
      }

      void modifySplatRotationScale(vec3 originalCenter, vec3 modifiedCenter, inout vec4 rotation, inout vec3 scale) {
        // Calculate distance between current splat and the Camera-Robot line segment
        float d = segDist(originalCenter, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);

        // Scale down splats that are too close to the line to 0, making them disappear
        scale *= alpha;
      }

      void modifySplatColor(vec3 center, inout vec4 color) {
        // Apply the same transition to the alpha channel as a double-safeguard
        float d = segDist(center, uCutA, uCutB);
        float alpha = smoothstep(uCutRadius, uCutRadius + uCutFeather, d);
        color.a *= alpha;
      }
    `;

    gsplatMat.getShaderChunks("glsl").set("gsplatModifyVS", glsl);
    gsplatMat.update();

    const uCutA = device.scope.resolve("uCutA");
    const uCutB = device.scope.resolve("uCutB");
    const uCutRadius = device.scope.resolve("uCutRadius");
    const uCutFeather = device.scope.resolve("uCutFeather");
    uCutRadius.setValue(0.5);
    uCutFeather.setValue(0.01);

    const onUpdate = () => {
      if (!hiddenNearRef.current || !hiddenFarRef.current) {
        return;
      }
      const nearPosition = hiddenNearRef.current.getPosition().clone();
      const farPosition = hiddenFarRef.current.getPosition().clone();
      if (nearPosition.length() === 0 || isNaN(nearPosition.x)) return;
      const dirToCamera = new pc.Vec3().sub2(nearPosition, farPosition);
      const totalDist = dirToCamera.length();
      dirToCamera.normalize();
      uCutA.setValue([nearPosition.x, nearPosition.y, nearPosition.z]);
      uCutB.setValue([farPosition.x, farPosition.y, farPosition.z]);
    };
    app.on("update", onUpdate);
    return () => app.off("update", onUpdate);
  };

  const SogSplat = ({ url }: { url: string }) => {
    const app = useApp();
    const gsplatRef = useRef();

    const { asset, error } = useSplat(url);

    useEffect(() => {
      if (!asset) {
        return;
      }
      const gsplatEntity = gsplatRef.current;
      if (!gsplatRef.current || !app) return;
      gsplatRef.current.gsplat.enabled = false;
      gsplatRef.current.gsplat.unified = true;
      gsplatRef.current.gsplat.asset = asset;
      setupCleanup();
      app.on("update", onUpdate);
      return () => app.off("update", onUpdate);
    }, [asset]);

    const setupCleanup = () => {
      const cleanup = installCameraNearFar(app, gsplatEntity);
      return cleanup;
    };

    const onUpdate = () => {
      if (isTrackerFound.current && !gsplatRef.current.gsplat.enabled) {
        gsplatRef.current.gsplat.enabled = true;
      }
    };

    return (
      <Entity ref={gsplatRef} rotation={[180, 0, 0]}>
        <GSplat />
      </Entity>
    );
  };

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      console.log(xChange);
      if (xChange > 1) {
        gsplatRotateEntity.current.rotateLocal(0, 2, 0);
      } else if (xChange < -1) {
        gsplatRotateEntity.current.rotateLocal(0, -2, 0);
      }
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        <ArObject />
        {/*<ArCamera />*/}
        <MainCamera />
      </>
    );
  };

  const Scene = () => {
    return (
      <Application>
        <PlaycanvasScene />
      </Application>
    );
  };

  const WebAR = ({
    className = "",
    defaultTracker = "",
    onTrackerFound = () => {},
    onTrackerLost = () => {},
    onTrackerLoaded = () => {},
    onPositionUpdate = () => {},
    onObjectUpdate = () => {},

    onSlamUpdate = () => {},
    onChildUpdate = () => {},
    onCameraUpdate = () => {},
  }) => {
    //const deviceType = getDeviceType();
    const iframeRef = useRef(null);
    const [isARReady, setIsARReady] = useState(false);
    const [isTracking, setIsTracking] = useState(false);
    const [currentTracker, setCurrentTracker] = useState(defaultTracker);
    const [latestPosition, setLatestPosition] = useState(null);
    const [log1, setLog1] = useState("");
    const [log2, setLog2] = useState("");
    const [log3, setLog3] = useState("");
    const [log4, setLog4] = useState("");

    const tempMat4Ref = useRef(new pc.Mat4());

    const handleMessage = useCallback(
      (event) => {
        if (event.source !== iframeRef.current?.contentWindow) return;

        const {
          type,
          tracker,
          trackerName,
          error,
          name,
          position,
          rotation,
          scale,
          data,
        } = event.data;

        switch (type) {
          case "ar-ready":
            // console.log(
            //   "WebAR: Ready with tracker:",
            //   trackerName || tracker,
            // );
            setIsARReady(true);
            setCurrentTracker(tracker);
            onTrackerLoaded({ tracker, trackerName, ready: true });
            break;

          case "tracker-error":
            //console.error("WebAR: Tracker failed:", error);
            setIsARReady(false);
            break;

          case "image-tracked":
            //console.log("WebAR: TRACKER FOUND:", name, position);
            setIsTracking(true);
            setLatestPosition(position);
            onTrackerFound({ name, position, rotation, scale });
            break;

          case "image-lost":
            //console.log("WebAR: TRACKER LOST:", name);
            setIsTracking(false);
            setLatestPosition(null);
            onTrackerLost({ name });
            break;
          case "child-update":
            onChildUpdate({ position, rotation });
            setLog1(
              position.x.toFixed(3) +
                " " +
                position.y.toFixed(3) +
                " " +
                position.z.toFixed(3),
            );
            setLog2(
              rotation.x.toFixed(3) +
                " " +
                rotation.y.toFixed(3) +
                " " +
                rotation.z.toFixed(3) +
                " " +
                rotation.w.toFixed(3),
            );
            break;
          case "camera-update":
            onCameraUpdate({ data });
            break;
        }
      },
      [onTrackerFound, onTrackerLost, onTrackerLoaded, onPositionUpdate],
    );

    const loadTracker = useCallback((trackerUrl) => {
      console.log("📥 WebAR: Loading tracker:", trackerUrl);
      const iframe = iframeRef.current;
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(
          { type: "load-tracker", url: trackerUrl },
          "*",
        );
      }
    }, []);

    useEffect(() => {
      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
    }, [handleMessage]);

    useEffect(() => {
      if (defaultTracker != "") {
        const timeout = setTimeout(() => loadTracker(defaultTracker), 500);
        return () => clearTimeout(timeout);
      }
    }, [defaultTracker, loadTracker]);

    return (
      <div className={`w-full h-screen fixed inset-0 bg-black ${className}`}>
        <iframe
          ref={iframeRef}
          src="https://assets.deepworldmodel.ai/ar/imageTrackerBridge/index.html"
          // src="imageTrackerBridge/index.html"
          className="w-full h-full border-0"
          allow="camera; gyroscope; accelerometer; magnetometer"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-top-navigation"
          style={{ display: "block" }}
          title="WebAR"
        />

        {/*        <div className="fixed top-2 left-4 z-60 p-4 bg-black/70 text-white rounded-xl shadow-2xl max-w-sm">
          {deviceType}
        </div>
        <div className="fixed top-20 left-4 z-60 p-4 bg-black/70 text-white rounded-xl shadow-2xl max-w-sm">
          {log1}
        </div>
        <div className="fixed top-40 left-4 z-60 p-4 bg-black/70 text-white rounded-xl shadow-2xl max-w-sm">
          {log2}
        </div>
        <div className="fixed top-60 left-4 z-60 p-4 bg-black/70 text-white rounded-xl shadow-2xl max-w-sm">
          {log3}
        </div>
        <div className="fixed top-80 left-4 z-60 p-4 bg-black/70 text-white rounded-xl shadow-2xl max-w-sm">
          {log4}
        </div>*/}
      </div>
    );
  };

  return (
    <div className="absolute top-0 left-0 w-full h-full">
      {isArStarted ? (
        <>
          <WebAR
            defaultTracker="https://assets.deepworldmodel.ai/ar/imageTrackerBridge/image-targets/tracker.json"
            // defaultTracker="/imageTrackerBridge/image-targets/tracker.json"
            onTrackerFound={(data) => {
              console.log("React FOUND!", data.position);
              isTrackerFound.current = true;
            }}
            onTrackerLost={() => {
              console.log("React LOST");
              isTrackerFound.current = false;
            }}
            onTrackerLoaded={({ trackerName }) =>
              console.log("React tracker ready:", trackerName)
            }
            onChildUpdate={(data) => {
              latestChildPosition.current.set(
                data.position.x,
                data.position.y,
                data.position.z,
              );
              latestChildRotation.current.set(
                data.rotation.x,
                data.rotation.y,
                data.rotation.z,
                data.rotation.w,
              );
            }}
            onCameraUpdate={(data) => {
              latestCameraData.current = data.data;
            }}
          />
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
            <Scene />
          </div>
        </>
      ) : (
        <div className="absolute top-0 left-0 w-full h-full bg-black">
          <div className="top-2 left-4 p-4 text-white">
            <div>Gyroscope permission</div>
            {
              // gyroscopePermissionStatus == "denied" ? (
              //   <div className="text-red-500">Permission denied</div>
              // ) :
              gyroscopePermissionStatus == "granted" ? (
                <div className="text-green-500">Permission granted</div>
              ) : gyroscopePermissionStatus == "denied" ||
                gyroscopePermissionStatus == "prompt" ? (
                <div>
                  <button
                    onClick={grantGyroscopePermission}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold my-2 py-2 px-6 rounded transition duration-300"
                  >
                    Grant
                  </button>
                </div>
              ) : (
                <></>
              )
            }
          </div>
        </div>
      )}
      <DragController />
    </div>
  );
}
